module.exports = __webpack_public_path__ + "static/media/Vandpunkten.221102f3.pdf";